'use client';

import { useState } from 'react';

import { FormSubmissionModal } from '@/components/forms/FormSubmissionModal/FormSubmissionModal';
import PrimaryCareServicesSection from '@/components/sections/PrimaryCareServicesSection';
import {
  serviceEnquiryDefaultValues,
  serviceEnquiryFields,
  serviceEnquirySchema,
} from '@/features/enquiries/forms/serviceEnquirySchema';
import type { CareServicesSection } from '@/features/paediatricClinic/data/paediatricClinic.types';

type PaediatricClinicCareServicesSectionClientProps = {
  careServices?: CareServicesSection;
  metadata?: Record<string, unknown>;
};

export default function PaediatricClinicCareServicesSectionClient({
  careServices,
  metadata,
}: PaediatricClinicCareServicesSectionClientProps) {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [hasBeenOpened, setHasBeenOpened] = useState(false);

  return (
    <>
      <PrimaryCareServicesSection
        data={careServices}
        onEnquireNow={() => {
          setHasBeenOpened(true);
          setEnquiryOpen(true);
        }}
      />

      {hasBeenOpened && (
        <FormSubmissionModal
          open={enquiryOpen}
          onOpenChange={setEnquiryOpen}
          formId="serviceEnquiry"
          schema={serviceEnquirySchema}
          fields={serviceEnquiryFields}
          defaultValues={serviceEnquiryDefaultValues}
          title="Baby Development Bundle (0 - 1 Year)"
          description="Fill in your details and our team will contact you."
          submitLabel="Send enquiry"
          metadata={metadata}
        />
      )}
    </>
  );
}
